import React from 'react';

import Modal from '../../../common/modal/Modal';
import { SaveButton } from '../../../common/button/save-button/SaveButton';

export const ParticipantsLinkedScheduleModal = ({ closeModal, scheduleName }) => {
  return (
    <Modal
      closeModal={closeModal}
      setIsModalOpen={closeModal}
      headerTitle="Remove Schedule"
      hideButton
      width="540px"
      height="max-content"
      contentPadding="20px"
      justifyContent="center"
    >
      <div className="visit-pack-warning-modal">
        <p className="visit-pack-warning-modal-message">
          {scheduleName
            ? `${scheduleName} schedule cannot be removed because participants have been linked to this schedule or 
                visits have been captured against this schedule.`
            : 'This schedule cannot be removed because participants or visits have been linked to it.'}
        </p>

        <div className="visit-pack-warning-modal-buttons">
          <SaveButton
            color="#6f8695"
            border="1px solid #6f8695"
            textColor="#ffffff"
            title="Close"
            onClick={closeModal}
          />
        </div>
      </div>
    </Modal>
  );
};
